

export const index = 4;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/links/_page.svelte.js')).default;
export const imports = ["_app/immutable/nodes/4.C8jeKRE4.js","_app/immutable/chunks/DowcGjab.js","_app/immutable/chunks/BzCi4Of2.js","_app/immutable/chunks/DuUomSZU.js"];
export const stylesheets = ["_app/immutable/assets/4.B9RX72TI.css"];
export const fonts = [];
